import ringplanMeetIcon from "./../../../../../assets/images/icon/ringplan_meet.svg";

const MeetIcon = () => <img src={ringplanMeetIcon} alt="" />;

export default MeetIcon;
